"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInputField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _FormControl = require("./FormControl");

var _InputLabel = require("./InputLabel");

var _FormHelperText = require("./FormHelperText");

var _RadioInput = require("./RadioInput");

var _components = require("./components");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  options: _propTypes.any,
  id: _propTypes.string,
  name: _propTypes.string,
  label: _propTypes.string,
  helperText: _propTypes.string,
  value: _propTypes.any,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  error: _propTypes.any,
  success: _propTypes.any,
  warning: _propTypes.any,
  disabled: _propTypes.any,
  FormHelperTextProps: _propTypes.any,
  noOutline: _propTypes.bool,
  fullWidth: _propTypes.bool
} : {};
const RadioInputsWrapper = _stylitas.styled.div`
  ${_components.inputGroup};
`;
const RadioInputsWrapperBlock = _stylitas.styled.div`
  ${_components.inputGroupBlock};
`;
const RadioInputNoOutline = _stylitas.styled.fieldset`
  ${_components.radioInputNoOutline}
`;
const fieldset = _stylitas.styled.fieldset``;

const RadioInputField = ({
  options,
  FormHelperTextProps,
  id,
  name,
  label,
  helperText,
  value,
  onChange,
  onBlur,
  error,
  success,
  warning,
  disabled,
  noOutline,
  fullWidth,
  ...inputProps
}) => {
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const [optionValue, setChecked] = (0, _react.useState)(value);
  const InputFieldset = noOutline ? RadioInputNoOutline : fieldset;
  const RadiosWrapper = fullWidth ? RadioInputsWrapperBlock : RadioInputsWrapper;
  return (0, _core.jsx)(RadioInputsWrapper, inputProps, (0, _core.jsx)(_FormControl.FormControl, {
    success: success,
    warning: warning,
    disabled: disabled,
    error: error
  }, (0, _core.jsx)(InputFieldset, {
    tabIndex: 0,
    noOutline: noOutline
  }, label && (0, _core.jsx)(_InputLabel.InputLabel, null, label), (0, _core.jsx)(RadiosWrapper, null, options.map(option => {
    const optionId = `${name}_${option.value}`;
    return (0, _core.jsx)(_RadioInput.RadioInput, (0, _extends2.default)({
      key: option.value,
      name: name,
      id: optionId,
      value: option.value,
      error: error,
      checked: option.value === optionValue,
      onBlur: onBlur,
      onChange: () => {
        setChecked(option.value);
        return onChange(option.value);
      },
      label: option.text,
      fullWidth: fullWidth
    }, inputProps));
  })), helperText && (0, _core.jsx)(_FormHelperText.FormHelperText, (0, _extends2.default)({
    tabIndex: 0,
    error: error,
    id: helperTextId
  }, FormHelperTextProps), helperText))));
};

exports.RadioInputField = RadioInputField;
process.env.NODE_ENV !== "production" ? RadioInputField.propTypes = propTypes : void 0;